<app-dialog-header>{{ data.title }}</app-dialog-header>

<div
  appDialogContent
  class="dialog-content">
  <section class="form">
    <div class="dcontents">
      <app-form-field label="First name">
        <input [formControl]="form.controls.first_name" />
      </app-form-field>

      <app-form-field label="Last name">
        <input [formControl]="form.controls.last_name" />
      </app-form-field>
    </div>

    <div class="dcontents">
      <app-form-field label="Email">
        <input
          type="email"
          [formControl]="form.controls.email" />
        @if (form.controls.email.hasError('required')) {
          <span appError>Email is required</span>
        } @else if (form.controls.email.hasError('email')) {
          <span appError>{{ emailError() }}</span>
        }
      </app-form-field>
    </div>

    <app-select
      label="Role"
      [options]="roleOptions()"
      [formControl]="form.controls.role" />

    @if (!company()?.id) {
      <app-multi-select
        label="Companies"
        class="full-row"
        placeholder="Select companies"
        searchable
        selectAll
        [options]="companyOptions()"
        [formControl]="form.controls.companyIdList" />
    }

    @if (showSqlQueryAccess()) {
      <app-checkbox
        class="sql-access"
        [formControl]="form.controls.sqlQueryAccess"
        appTooltip="Allows read-only SQL queries to test company databases (qa-psql). Super user has access only to their own companies.">
        SQL query access
      </app-checkbox>
    }

    @if (showSqlWriteAccess()) {
      <app-checkbox
        class="sql-access"
        [formControl]="form.controls.sqlWriteAccess"
        appTooltip="Allows data changes (INSERT, UPDATE, DELETE, MERGE) in test company databases via qa-psql. Requires SQL query access.">
        SQL write access
      </app-checkbox>
    }
  </section>
</div>

<div
  appDialogActions
  align="end">
  <app-button
    variant="stroked"
    color="neutral"
    appDialogClose>
    Cancel
  </app-button>
  <app-button
    [disabled]="isInvalid()"
    (click)="save()">
    Confirm
  </app-button>
</div>
